export default __webpack_public_path__ + "static/media/cancel-white.f8768630.svg";